import React, { useEffect, useState } from "react";
import { Form, Skeleton, message, Row, Col } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, InputDate, SelectWithSearch, SelectResourceList } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { updateTargetIncentiveConfigReq, getOrgFieldsReq } from "../requests";
import { Commons, Const } from "../../constants";
import { createSelectList } from '@comps/commonFunctions';
import dayjs from 'dayjs';
import { makeFieldLabel } from "@utils/fieldTooltips";
import { payrollHelpText } from "../../payrollHelpText";


const langKey = Const["targetIncentives"].lngKey


const fieldLabel = makeFieldLabel(payrollHelpText.targetIncentive, { namespace: "targetIncentive", label: (key) => trans(`${langKey}.${key}`) });
const formName = "createAttendanceRequest";
const UpdateTargetIncentiveConfiguration = (props) => {
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [allowOvertime, setAllowOvertime] = useState(true);
  const [orgFieldName, setOrgFieldName] = useState('grade');
  const [form] = Form.useForm()
  const [orgFields, setOrgFields] = useState([]);
  const [type, setType] = useState('monthly');
  useEffect(() => {
    getRelatedData()
    // eslint-disable-next-line
  }, []);

  const getRelatedData = () => {
    props.record.start_date = props.record.start_date ? dayjs(props.record.start_date) : null;
    props.record.end_date = props.record.end_date ? dayjs(props.record.end_date) : null;
    props.record.qa_ids = normalizeIds(
      props.record.qa_ids ?? props.record.qa_ids_array ?? props.record.qa_id
    );
    props.record.shift_incharge_ids = normalizeIds(
      props.record.shift_incharge_ids ?? props.record.shift_incharge_ids_array
    );
    setType(props.record.type);
    setOrgFieldName(props.record.organization_field_name);
    setAllowOvertime(props.record.is_allow_overtime);
    // props.record.start_date = props.record.start_date ? dayjs(props.record.start_date) : null;
    // props.record.end_date = props.record.end_date ? dayjs(props.record.end_date) : null;
    form.setFieldsValue(props.record);
    setLoading(true)
    makeRequest(setLoader, getOrgFieldsReq, null, onGetOrgFields, onGetOrgFields);
  }
  const onGetOrgFields = (data, res) => {
    setLoading(false)
    const fields = {
      grade: createSelectList(res.organization_structure_data.grade),
      department: createSelectList(res.organization_structure_data.department),
      designation: createSelectList(res.organization_structure_data.designation),
      job_titles: createSelectList(res.organization_structure_data.job_title),

    }
    setOrgFields(fields);


  }

  const onSubmit = (data) => {
    data.start_date = data.start_date ? data.start_date.format('YYYY-MM-DD') : '';
    data.end_date = data.end_date ? data.end_date.format('YYYY-MM-DD') : '';
    const payload = {
      id: props.record.id,
      target_incentive_config: { ...props.record, ...data }
    }
    makeRequest(setLoader, updateTargetIncentiveConfigReq, payload, onSuccess, onError);
    setSaveLoader(true)
  }
  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success(res.message);
    props.onCompleted(data);
  }

  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }
  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    props.action &&
    <SaveButton loading={ saveLoader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];
  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------
  return (
    <ModalComponent top={ 20 } width={ 1000 } maskClosable={ false }
      mainTitle={ trans(Commons.update) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>
        <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit } disabled={ props.disabled }>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="title" rules={ rules.title } label={ fieldLabel("title", trans(`${langKey}.title`)) }
                className="da-mb-16"

              >
                <InputText placeholder={ trans(`${langKey}.title`) } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="organization_field_name" rules={ rules.organization_field_name } label={ fieldLabel("organization_field_name", trans(`${langKey}.organization_field_name`)) }
                className="da-mb-16"
                initialValue={ orgFieldName }
              >
                <SelectWithSearch
                  onChange={ setOrgFieldName }
                  options={ [
                    {
                      label: 'Grade',
                      value: 'grade'
                    },
                    {
                      label: 'Designation',
                      value: "designation"
                    },
                    {
                      label: 'Job Title',
                      value: "job_title"
                    },
                    {
                      label: 'Department',
                      value: "department"
                    },

                  ] }
                  placeholder={ trans(`${langKey}.organization_field_name`) }
                />
              </Form.Item>
            </Col>


            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="organization_field_value" rules={ rules.organization_field_value } label={ fieldLabel("organization_field_value", trans(`${langKey}.organization_field_value`)) }
                className="da-mb-16"

              >
                <SelectWithSearch
                  options={ orgFields[orgFieldName] }
                  placeholder={ trans(`${langKey}.organization_field_value`) }
                />

              </Form.Item>
            </Col>


            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="type" rules={ rules.type } label={ fieldLabel("type", trans(`${langKey}.type`)) }
                className="da-mb-16"
                initialValue={ type }
              >
                <SelectWithSearch
                  options={ [
                    // {
                    //   label: "Daily",
                    //   value: 'daily'
                    // },
                    {
                      label: "Monthly",
                      value: 'monthly'
                    }
                  ] }
                  placeholder={ trans(`${langKey}.type`) }
                  onChange={ (e) => setType(e) }
                />
              </Form.Item>
            </Col>


            {/* <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="date" rules={ rules.date } label={ fieldLabel("date", type === 'monthly' ? trans(`${langKey}.month`) : trans(`${langKey}.date`)) }
                className="da-mb-16"

              >
                <InputDate picker={ type === 'daily' ? 'date' : "month" } />
              </Form.Item>
            </Col> */}


            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="no_of_cases" rules={ rules.no_of_cases } label={ fieldLabel("no_of_cases", trans(`${langKey}.no_of_cases`)) }
                className="da-mb-16"

                initialValue={ 0 }
              >
                <InputText placeholder={ trans(`${langKey}.no_of_cases`) } type="number" onWheel={ (e) => e.target.blur() } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="case_price" rules={ rules.case_price } label={ fieldLabel("case_price", trans(`${langKey}.case_price`)) }
                className="da-mb-16"

                initialValue={ 0 }
              >
                <InputText placeholder={ trans(`${langKey}.case_price`) } type="number" onWheel={ (e) => e.target.blur() } />
              </Form.Item>
            </Col>

            {
              props.action == "apply" &&
              <>

                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="start_date" rules={ rules.start_date } label={ fieldLabel("start_date", "Start date") }
                    className="da-mb-16"

                  >
                    <InputDate placeholder={ "Start date" } disabled={ false } />
                  </Form.Item>
                </Col>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="end_date" rules={ rules.end_date } label={ fieldLabel("end_date", "End date") }
                    className="da-mb-16"

                  >
                    <InputDate placeholder={ "End date" } disabled={ false } />
                  </Form.Item>
                </Col>
              </>
            }
            {/* <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_allow_overtime" rules={ rules.is_allow_overtime } label={ fieldLabel("is_allow_overtime", trans(`${langKey}.is_allow_overtime`)) }
                className="da-mb-16"
                initialValue={ allowOvertime }
              >
                <SelectWithSearch onChange={ setAllowOvertime } placeholder={ trans(`${langKey}.is_allow_overtime`) } options={
                  [
                    {
                      label: "Yes",
                      value: 1
                    },
                    {
                      label: "No",
                      value: 0
                    }
                  ] } />

              </Form.Item>
            </Col> */}



            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="overtime_case_price" rules={ rules.overtime_case_price } label={ fieldLabel("overtime_case_price", trans(`${langKey}.overtime_case_price`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['overtime_case_price']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.overtime_case_price`) } type="number" onWheel={ (e) => e.target.blur() } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="qa_ids" rules={ rules.qa_ids } label={ fieldLabel("qa_ids", "Select QAs") }
                className="da-mb-16"

              >
                <SelectResourceList mode="multiple" placeholder={ "Select QAs" } type="employment" value={ props.record.qa_ids } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="shift_incharge_ids" rules={ rules.shift_incharge_ids } label={ fieldLabel("shift_incharge_ids", "Select Shift Incharges") }
                className="da-mb-16"

              >
                <SelectResourceList mode="multiple" placeholder={ "Select Shift Incharges" } type="employment" value={ props.record.shift_incharge_ids } />
              </Form.Item>
            </Col>
            {/* 
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="min_cases_for_overtime" rules={ rules.min_cases_for_overtime } label={ fieldLabel("min_cases_for_overtime", trans(`${langKey}.min_cases_for_overtime`)) }
                    className="da-mb-16"
                    { ...getErrorProps(errors['min_cases_for_overtime']) } size="small"
                  >
                    <InputText placeholder={ trans(`${langKey}.min_cases_for_overtime`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>
              */}


            {/* <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="start_date" rules={ rules.start_date } label={ fieldLabel("start_date", "Start date") }
                className="da-mb-16"

              >
                <InputDate picker={ "date" } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="end_date" rules={ rules.end_date } label={ fieldLabel("end_date", "End date") }
                className="da-mb-16"

              >
                <InputDate picker={ "date" } />
              </Form.Item>
            </Col> */}

            {/* <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_active" rules={ rules.is_active } label={ fieldLabel("is_active", trans(`${langKey}.is_active`)) }
                className="da-mb-16"
                initialValue={ allowOvertime }
              >
                <SelectWithSearch onChange={ setAllowOvertime } placeholder={ trans(`${langKey}.is_active`) } options={
                  [
                    {
                      label: "Yes",
                      value: 1
                    },
                    {
                      label: "No",
                      value: 0
                    }
                  ] } />

              </Form.Item>
            </Col> */}

          </Row>

        </Form>
      </Skeleton>
    </ModalComponent>
  )
}

export default UpdateTargetIncentiveConfiguration

const normalizeIds = (value) => {
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === "string") {
    return value.split(",").map((id) => id.trim()).filter(Boolean);
  }
  if (value || value === 0) {
    return [value];
  }
  return [];
}

const rules = {
  organization_field_name: [
    { required: true, message: trans(`${langKey}.organization_field_name.req`) },
  ],
  organization_field_value: [
    { required: true, message: trans(`${langKey}.organization_field_value.req`) },
  ],
  date: [
    { required: true, message: trans(`${langKey}.date.req`) },
  ],
  case_price: [
    { required: true, message: trans(`${langKey}.case_price.req`) },
  ],
  overtime_case_price: [
    { required: true, message: trans(`${langKey}.overtime_case_price.req`) },
  ],
  type: [
    { required: true, message: trans(`${langKey}.type.req`) },
  ],
  min_cases_for_overtime: [
    { required: true, message: trans(`${langKey}.min_cases_for_overtime.req`) },
  ],
  is_allow_overtime: [
    { required: true, message: trans(`${langKey}.is_allow_overtime.req`) },
  ],
  no_of_cases: [
    { required: true, message: trans(`${langKey}.no_of_cases.req`) },
  ],
  qa_ids: [
    { required: true, message: "Select QAs" },
  ],
  shift_incharge_ids: [
    { required: true, message: "Select Shift Incharges" },
  ],
  start_date: [
    { required: true, message: trans(`${langKey}.start_date.req`) },
  ],
  end_date: [
    { required: true, message: trans(`${langKey}.end_date.req`) },
  ],
};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
